module.exports = __webpack_public_path__ + "static/media/mosque.d2be6674.svg";